<template>
    <div class="v-paging st-paging">

        {{ $t('Page') }}
        <div class="inline-block">
        	<button class="st-btn st-btn--small" @click="prev()" :disabled="current_page <= min_page">
        		<i class="fa fa-angle-left" aria-hidden="true"></i>
        	</button>
        </div>
        <input size="2" class="inline text-center st-input st-input--fit st-input--small" :disabled="current_page >= max_page && current_page <= min_page" type="text" @keyup="pagechange" v-model="current_page"> {{ $t('to') }} {{ max_page }}
        <div class="inline-block">
        	<button class="st-btn st-btn--small" @click="next()" :disabled="current_page >= max_page">
        		<i class="fa fa-angle-right" aria-hidden="true"></i>
        	</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'v-paging',
	props: {
		current_page: {
			type: Number,
			default: 0
	    },
	    min_page: {
			type: Number,
			default: 0
	    },
	    max_page: {
			type: Number,
			default: 0
	    }
	},
	methods: {
		pagechange: function () {
			const self = this;
			if(self.current_page > self.max_page){
				self.current_page = self.max_page;
			}
			if(self.current_page < self.min_page){
				self.current_page = self.min_page;
			}

			if (this.timeoutId) window.clearTimeout(this.timeoutId);
	      	this.timeoutId = window.setTimeout(function () {
				self.$emit('pagechange', self.current_page);
	      	}, 500);
        },
		prev: function () {
            this.$emit('prev', -1);
        },
        next: function () {
            this.$emit('next', +1);
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/v-paging.vue